import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import config from '../config';
import { jwtDecode } from 'jwt-decode';
import { getUserIdFromStorageOrToken } from '../utils/authHelpers';

const BikeRentalCheckout = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [bookingData, setBookingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const currency = process.env.REACT_APP_CURRENCY || '€';
  const [userId, setUserId] = useState(null);
  
  useEffect(() => {
    // Get passed data (bike, rental date, time, duration, finalPrice)
    if (location.state) {
      setBookingData(location.state);
    } else {
      // No data passed, redirect back
      alert(t('bike.bookingError', 'An error occurred. Please repeat the booking process.'));
      navigate('/explorer');
    }
  }, [location, navigate, t]);

const handleConfirmAndPay = async () => {
  if (!bookingData) return;

  setLoading(true);
  try {
    const extractedUserId = getUserIdFromStorageOrToken();
    console.log('User ID:', extractedUserId);

    if (!extractedUserId) {
      alert(t('checkout.userError', 'User ID missing, please login again.'));
      setLoading(false);
      return;
    }

    const token = localStorage.getItem('token');

    const reqBody = {
      ...bookingData,
      amount: bookingData.finalPrice,
      userId: extractedUserId,
      language: i18n.language // 🔤 pass language to backend
    };
    
    console.log('📦 Sending to /initiate-bike-rental:', reqBody);
    
    const res = await fetch(config.getApiUrl('purchases/initiate-bike-rental'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(reqBody)
    });
    const data = await res.json();

    if (res.ok && data.url) {
      window.location.href = data.url; // ✅ Redirect to Stripe checkout
    } else {
      console.error('Booking initiation failed', data.message);
      alert(t('checkout.error', 'Error initiating payment. Please try again.'));
    }
  } catch (error) {
    console.error('Error initiating booking:', error);
    alert(t('checkout.error', 'Server error during payment.'));
  }

  setLoading(false);
};

  if (!bookingData) {
    return null; // Show nothing while redirecting
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 bg-gray-50">
      <div className="max-w-md w-full space-y-6">
        <h1 className="text-2xl font-bold text-center text-gray-800">
          {t('checkout.title', 'Confirm Your Bike Rental')}
        </h1>

        <div className="bg-white shadow rounded-lg p-4 space-y-2 text-gray-700">
          <div><strong>{t('checkout.bike', 'Bike')}:</strong> {bookingData.bikeModel} <small>({bookingData.bikeId})</small></div>
          <div><strong>{t('checkout.date', 'Date')}:</strong> {new Date(bookingData.rentalDate).toLocaleDateString(i18n.language)}</div>
          <div><strong>{t('checkout.time', 'Start Time')}:</strong> {bookingData.rentalTime}</div>
          <div><strong>{t('checkout.duration', 'Duration')}:</strong> {t(`bike.duration.${bookingData.rentalDuration}`, bookingData.rentalDuration)}</div>
          <div className="text-lg mt-4">
            <strong>{t('checkout.amount', 'Amount')}:</strong> {bookingData.finalPrice} {currency}
          </div>
        </div>

        <button
          onClick={handleConfirmAndPay}
          disabled={loading}
          className="w-full py-3 rounded-md text-white font-semibold transition bg-green-600 hover:bg-green-700"
        >
          {loading ? t('checkout.processing', 'Processing...') : t('checkout.payNow', 'Pay Now')}
        </button>
      </div>
    </div>
  );
};

export default BikeRentalCheckout;
